// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"ca1e0777","355":"f5753768"}[chunkId] + ".chunk.js";
};